import { RootState } from "../../app/state";
import { userAdapter } from "./helperState";

// const selectRoot = (state: RootState) => state;

export const selectHelperSlice = (state: RootState) => state.helperSlice;

const helperSelectors = userAdapter.getSelectors(selectHelperSlice);

export const selectAllHelperUsers = helperSelectors.selectAll;